import { useFormContext, } from 'react-hook-form';
import { useContext } from 'preact/compat';
import { getActivities, getSelectedActivities, setActivities } from '@genericBookings/store/reducers/activities';
import { useAppDispatch, useAppSelector } from '@genericBookings/store/hooks';
import { useTimeConflict } from '@bookingForm/context/TimeConflicts';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
import { useMessage } from '@genericBookings/context/Message';
export default function useSessionRefresh(options) {
    const { isMulti, isBuilder } = useContext(options);
    const { setValue, getValues } = useFormContext();
    const activitiesSelector = isBuilder ? getSelectedActivities : getActivities;
    const activities = useAppSelector(activitiesSelector);
    const dispatch = useAppDispatch();
    const { initTimePeriods } = useTimeConflict();
    const { modifyStep, sessionStep } = useStepCompletion();
    const { activityReset } = useMessage();
    return async (update = true) => {
        modifyStep(sessionStep, false);
        activities.forEach((activity) => { activityReset(activity.activity.id); });
        if (!isMulti && !isBuilder) {
            setValue('session', null);
            const activity = activities[0];
            if (activity) {
                const updatedActivities = [{
                        ...activity,
                        activeSession: undefined,
                    }];
                if (update) {
                    await dispatch(setActivities(updatedActivities));
                }
                return updatedActivities;
            }
        }
        else {
            if (isMulti) {
                initTimePeriods([]);
            }
            const sessionsValue = getValues('Sessions');
            setValue('Sessions', sessionsValue.map((session) => ({
                ...session,
                SessionId: null,
            })));
            const updatedActivities = activities.map((activity) => ({
                ...activity,
                activeSession: undefined,
            }));
            if (update) {
                await dispatch(setActivities(updatedActivities));
            }
            return updatedActivities;
        }
        return activities;
    };
}
